<!--
 * @Author: mzw
 * @Date: 2025-04-23 10:27:06
 * @LastEditTime: 2025-04-23 10:27:06
 * @LastEditors: mzw
 * @Description: 物料助手-选择推荐商品
-->
<template>
  <el-dialog
    :visible.sync="visible"
    title="推荐商品"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="onCancel"
    width="800px"
  >
    <Table
      ref="table"
      :tableConfig="tableConfig"
      @checked="checked"
    >
    </Table>
  </el-dialog>
</template>

<script>
import Table from '@/components/table/index';

export default {
  name: 'MaterialGoods',
  components: {
    Table
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    taskDetailId: {
      type: String,
      default: ''
    },
    extraData: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {
      tableConfig: {
        autoSearch: false, // 是否需要默认查询
        extra: {
        }, // 额外的参数 用于搜索,不在search组件内的参数
        searchUrl: '/help/ai/user/materialAssistant/detail/getRecommendGoodsList', // 发送请求方法
        searchMethod: 'POST', // 接口请求方式
        showOrdinal: true,
        needPagination: false,
        maxHeight: "500px",
        resultListName: '',
        radioInfo: {
          key: 'skuCode'
        },
        params: [
          {
            prop: "skuCode",
            label: "商品编码",
            width: "140",
            showOverflowTooltip: true
          },
          {
            prop: "skuName",
            label: "商品名称",
            width: "140",
            showOverflowTooltip: true
          },
          {
            prop: "brandName",
            label: "商品品牌",
            showOverflowTooltip: true
          },
          {
            prop: "specification",
            label: "规格",
            showOverflowTooltip: true
          },
          {
            prop: "model",
            label: "型号",
            showOverflowTooltip: true
          },
          {
            prop: "matchScore",
            label: "推荐分值",
            width: '90'
          }
        ]
      }
    }
  },
  methods: {
    doSearch(val = {}) {
      this.tableConfig.extra = {
        ...val,
        materialBrandName: this.extraData.materialBrandName ||'',
        materialModel: this.extraData.materialModel ||'',
        materialShortName: this.extraData.materialShortName ||'',
        materialSpec: this.extraData.materialSpec ||'',
        taskDetailId: this.taskDetailId
      };
      this.$nextTick(() => {
        this.$refs.table.getList();
      });
    },
    checked(val) {
      // console.log(val.row)
      this.$emit('checked', val.row)
    },
    onCancel () {
      this.$emit('toggleVisible', false)
    }
  },
  mounted() {
    this.doSearch()
  }
}
</script>

<style lang='scss' scoped>

</style>